import router from "@/router";
import { useAppStore } from "@/stores/app"
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

export const useSeo = () => {
    const { seoConfig } = storeToRefs(useAppStore())

    const getSeoHeader = () => computed(() => {
        const { description, image, keywords, title } = seoConfig.value
        const currentPath = router.currentRoute?.value?.path ?? ''
        const appTitle = import.meta.env.VITE_APP_TITLE
        const ogTitle = title || appTitle
        return {
            meta: [
                { name: 'description', content: description },
                { name: 'keywords', content: keywords },
                { property: 'og:title', content: ogTitle },
                { property: 'og:locale', content: import.meta.env.VITE_OG_LOCALE },
                { property: 'og:image', content: image },
                { property: 'og:description', content: description },
                { property: 'og:type', content: 'website' },
            ],
            link: [
                { rel: 'canonical', href: `${window.location.protocol}//${window.location.host}/#${currentPath}` }
            ]
        }
    })

    return {
        getSeoHeader
    }
}